var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoryAdminSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2542 18.1659L20.2282 33.1919C16.8111 36.609 11.2709 36.609 7.85383 33.1919C4.43674 29.7749 4.43674 24.2347 7.85383 20.8176L22.8798 5.79155C25.1579 3.51349 28.8514 3.51349 31.1294 5.79155C33.4075 8.06961 33.4075 11.7631 31.1294 14.0411L16.6927 28.4779C15.5536 29.6169 13.7069 29.6169 12.5679 28.4779C11.4288 27.3389 11.4288 25.4921 12.5679 24.3531L25.2369 11.6841",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryAdminSupport);
export default __webpack_public_path__ + "react/media/category-admin_support.fdabb07048bdd1cf6212ebae36585fd0.svg";
export { ForwardRef as ReactComponent };